/*
 * Yurls Shop — boekjes bijleggen vanaf de winkelwagen.
 *
 * Legt een boekje bij en laadt daarna de winkelwagen opnieuw.
 *
 * Dat opnieuw laden is een bewuste keuze en geen luiheid. De nettere weg is
 * alleen de regels en het overzicht vervangen met wat de server terugstuurt,
 * en dat is ook geprobeerd — twee keer, op twee manieren:
 *
 *   • via de sectie-API van Shopify (sections=…): die verzoeken worden niet
 *     altijd afgehandeld door het thema dat je op dat moment bekijkt. In een
 *     voorbeeldweergave kwam de winkelwagen van het gepubliceerde thema terug.
 *   • door de pagina zelf opnieuw op te halen: hetzelfde probleem, want ook
 *     dat verzoek kan bij het andere thema uitkomen zodra de voorbeeldsessie
 *     verloopt.
 *
 * In beide gevallen belandde er opmaak van een ander thema midden in deze
 * pagina: het overzicht en de bundelbalk verdwenen en de regels kregen een
 * heel andere vorm. Op de winkelwagen — de enige pagina waar een fout direct
 * geld kost — is dat het niet waard.
 *
 * Opnieuw laden kan niet misgaan en levert bovendien betere bevestiging op dan
 * een knop die even "Toegevoegd" zegt: je ziet je boekje in de lijst staan, de
 * bundelbalk opschuiven en het totaal veranderen.
 *
 * Wil je dit later toch zonder herladen, dan is de voorwaarde dat het thema
 * gepubliceerd is; dan werkt de sectie-API wel betrouwbaar.
 */

if (!customElements.get('yurls-cart-upsell')) {
  customElements.define(
    'yurls-cart-upsell',
    class YurlsCartUpsell extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          var button = event.target.closest('[data-add]');
          if (!button) return;
          event.preventDefault();
          this.add(button);
        });
      }

      add(button) {
        if (button.hasAttribute('aria-busy')) return;

        var label = button.querySelector('[data-label]') || button;
        var original = label.textContent;

        button.setAttribute('aria-busy', 'true');
        label.textContent = button.dataset.busy || 'Bezig…';

        var body = new FormData();
        body.append('id', button.dataset.variant);
        body.append('quantity', '1');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: body,
        })
          .then(function (response) { return response.json(); })
          .then(function (data) {
            if (data.status) throw new Error(data.description || data.message || 'mislukt');
            window.location.reload();
          })
          .catch(function () {
            label.textContent = original;
            button.removeAttribute('aria-busy');
          });
      }
    }
  );
}